<div class="clug-page candidates-page">
    <div class="page-head">
        <div class="title-block">
            <h1 class="page-title">Candidates</h1>
            <p class="lede">Manage every candidate available for assignment.</p>
        </div>
        <div class="action-bar">
            <button type="button" class="btn btn-primary" (click)="onAdd()">
                <i class="bi bi-plus-lg"></i><span>Add New</span>
            </button>
        </div>
    </div>

    <nav class="page-tabs">
        <a class="page-tab" routerLinkActive="active" routerLink="/candidates/active-candidates">Active</a>
        <a class="page-tab" routerLinkActive="active" routerLink="/candidates/inactive-candidates">Inactive</a>
    </nav>

    <router-outlet></router-outlet>
</div>